var adRefresh = require('src/interlock/product/ads/ad-manager/ad-retarget-refresh-manager');
var arrayFind = require('array-find');
var REFRESH_ZONES = require('src/interlock/product/ads/refresh-zones.js');

var slotIniter = null;
var _viewportZoneAds = [];
// Special case for carousel ads positioned in the left column that don't refresh correctly with slotVisibilityChanged
var _viewportSlideAds = [];

function isDependedOnViewPort(slot) {
    var adUnit = arrayFind(_viewportZoneAds, function (adUnit) {
        return adUnit.getContainerId() === slot.getSlotElementId();
    });

    adUnit = adUnit || arrayFind(_viewportSlideAds, function (adUnit) {
        return adUnit.getContainerId() === slot.getSlotElementId();
    });

    return adUnit;
}

function _addToViewPortAds(adUnit) {
    var refreshZones = adUnit.getRefreshZones();
    if(refreshZones.indexOf(REFRESH_ZONES.VIEWPORT) !== -1) {
        _viewportZoneAds.push(adUnit);
    } else if(refreshZones.indexOf(REFRESH_ZONES.VIEWPORT_SLIDE) !== -1) {
        // for carousel ads in left column of the slide
        _viewportSlideAds.push(adUnit);
    }
}


/**
 * TODO: Need to revisit to come up with a better solution for 1x1(hidden) ads.
 * _carouselSlideViewportAdsInView - uses slotIniter to determine the slot then refreshAdSlot.
 * @param $slide - takes in the active slide from owl carousel
 * @private
 *
 * i.e.
 * This current use case is for herooverlay for at-a-glance-carousel
 * File: src/creative/core-page/at-a-glance-carousel/at-a-glance-carousel.js
 *
 *   $(carouselOwl).on('translated.owl.carousel', function(e) {
 *       var $slide = $(e.target)
 *           .find('.owl-item')
 *           .eq(e.item.index);
 *       dependedOnViewportAd.setSlotIniter(gptSlotIniter);
 *       dependedOnViewportAd.carouselSlideViewportAdsInView($slide);
 *   });
 *
 */
function _carouselSlideViewportAdsInView($slide) {
    var viewportAdInView = arrayFind(_viewportZoneAds,function(adUnit) {
        return $slide.find('#'+adUnit.getContainerId()).length > 0;
    });
    viewportAdInView = arrayFind(_viewportSlideAds,function(slideAd) {
        // for carousel slide ads in left column
        return $slide.find('#'+slideAd.getContainerId()).length > 0;
    }) || viewportAdInView;
    if(!viewportAdInView && slotIniter) {
        return;
    }
    slotIniter.init(viewportAdInView);
    var slot = slotIniter.getAdIdToSlot();
    adRefresh.refreshAdSlot(slot[viewportAdInView.getId()]);
}

function _slotVisibilityChanged(event) {
    var adUnit = isDependedOnViewPort(event.slot);
    if(adUnit && adUnit.refreshed) {
        adUnit.refreshed = false;
    } else if(adUnit && adUnit.isHiddenInViewPort && event.inViewPercentage >= 50) {
        adRefresh.refreshAdSlot({'googleSlot': event.slot, moduleValue: adUnit.getModuleValue()});
        adUnit.isHiddenInViewPort = false;
    } else if(adUnit && event.inViewPercentage < 50) {
        adUnit.isHiddenInViewPort = true;
    }
}

function _carouselSlideAdRefresh($slide, adIdToSlot) {
    var adUnit = arrayFind(_viewportSlideAds, function(adUnit) {
        return $slide.find('#'+adUnit.getContainerId()).length > 0 ? adUnit : null;
    });
    if (adUnit) {
        adRefresh.refreshAllAdUnits([adUnit], adIdToSlot);

        adUnit.isHiddenInViewPort = false;
        adUnit.refreshed = true;
    }
}

/**
 * TODO: Need to figure out why we can't require('src/interlock/product/ads/ad-manager/gpt-slot-initer') in this file.
 * _setSlotIniter - set require('src/interlock/product/ads/ad-manager/gpt-slot-initer') so we can use it in this file
 * @param slotInit - require('src/interlock/product/ads/ad-manager/gpt-slot-initer')
 * @private
 */
function _setSlotIniter(slotInit) {
    slotIniter = slotInit;
}

module.exports = {
    addToViewPortAds : _addToViewPortAds,
    slotVisibilityChanged: _slotVisibilityChanged,
    setSlotIniter: _setSlotIniter,
    carouselSlideViewportAdsInView: _carouselSlideViewportAdsInView,
    carouselSlideAdRefresh: _carouselSlideAdRefresh
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-manager/depended-on-viewport-ad.js
// module id = 126
// module chunks = 36